<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="date_from">Date From</label>
            <b-input
              id="date_from"
              v-model="filter.date_from"
              type="date"
              @change="onFilterChanged"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="date_from">Date To</label>
            <b-input
              id="date_from"
              v-model="filter.date_to"
              type="date"
              @change="onFilterChanged"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="12"
        >
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        ref="table"
        hover
        responsive
        class="mt-2"
        :items="myProvider"
        :fields="tableSettings.fields"
        :filter="tableSettings.filter"
        :filter-included-fields="tableSettings.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>
      </b-table>
    </b-card>
  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import { SupervisorMonitoringService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'SupervisorLGATicket',

  middleware: ['auth', 'supervisor'],

  metaInfo () {
    return {
      title: 'Customer Service Raw Data'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        busy: false
      },
      filter: {
        team: 'All',
        date_from: this.dateFormatter(Date.now()),
        date_to: this.dateFormatter(Date.now())
      },
      tableSettings: {
        filter: '',
        filterOn: [],
        fields: [
          'index',
          { key: 'agent_name', label: 'Agent' },
          { key: 'assigned', label: 'Assigned Data' },
          { key: 'untouched', label: 'Untouched' },
          { key: 'called', label: 'Called' },
          { key: 'processed', label: 'Processed' },
          { key: 'unsuccessful', label: 'Unsuccessful Calls' },
          { key: 'invalid', label: 'Invalid' },
          { key: 'over_due', label: 'Over Due' }
        ]
      }
    }
  },

  mounted () {
    core.index()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await SupervisorMonitoringService.getCSORawData(
          this.objectToUrl({
            filter_text: ctx.filter,
            filter_from: this.filter.date_from,
            filter_to: this.filter.date_to
          })
        )
        return data.items
      } catch {
        return []
      }
    },

    onFilterChanged () {
      this.$refs.table.refresh()
    }
  }
}
</script>
